import { render, staticRenderFns } from "./NewsListElementComponent.vue?vue&type=template&id=32869d7c&scoped=true&"
import script from "./NewsListElementComponent.vue?vue&type=script&lang=js&"
export * from "./NewsListElementComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsListElementComponent.vue?vue&type=style&index=0&id=32869d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32869d7c",
  null
  
)

export default component.exports